<m-modal :open.sync="open"
         class="m-organize-table-columns-modal"
         size="small"
         :title="$i18n.translate('m-organize-table-columns-modal:title')">
    <slot slot="trigger"
          name="trigger">
        <m-button>{{ $i18n.translate('m-organize-table-columns-modal:title')}}</m-button>
    </slot>
    <m-organize-table-columns :columns="internalColumns"
                              @reorganize="reorganize">
    </m-organize-table-columns>
    <template #footer>
        <m-button class="m-organize-table-columns-modal__reorganize-button"
                  @click="saveReorganize()">
            {{ $i18n.translate('m-organize-table-columns-modal:action.reorganize') }}
        </m-button>
        <m-button @click="reset()"
                  skin="secondary">
            {{ $i18n.translate('m-organize-table-columns-modal:action.reset') }}
        </m-button>
    </template>
</m-modal>
